import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function FooterSection() {
  return (
    <footer className="pt-16 md:pt-20 pb-8 px-6 md:px-10 bg-secondary-800">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h4 className="font-heading text-lg font-bold text-background-50 mb-3">
              kakobuyspreadsheet<span className="text-accent-400">.ink</span>
            </h4>
            <p className="text-sm text-secondary-200 leading-relaxed">
              Your trusted resource for the best kakobuy spreadsheet guides, product lists, and shopping tips. Updated daily.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="Instagram">
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-700 text-secondary-200 hover:bg-accent-500 hover:text-background-50 transition-colors duration-200 cursor-pointer" aria-label="Pinterest">
                <i className="ri-pinterest-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 pb-2 border-b border-secondary-600">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#categories" className="text-sm text-secondary-200 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">Categories</a></li>
              <li><a href="#benefits" className="text-sm text-secondary-200 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">Why Choose Us</a></li>
              <li><a href="#guides" className="text-sm text-secondary-200 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">Shopping Guides</a></li>
              <li><Link to="/guide/best-kakobuy-spreadsheet-guide" className="text-sm text-secondary-200 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">Buying Guide</Link></li>
              <li><a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-secondary-200 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap">Kakobuy Spreadsheet</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 pb-2 border-b border-secondary-600">
              Popular Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-secondary-200 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 pb-2 border-b border-secondary-600">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(6).map((cat) => (
                <li key={cat.seq}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-secondary-200 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-secondary-600 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">
            &copy; {new Date().getFullYear()} kakobuyspreadsheet.ink &mdash; Your trusted kakobuy spreadsheet resource. All rights reserved.
          </p>
          <p className="text-xs text-secondary-300">
            Updated June 2026 &middot; Reviewed by Shopping Guide Editors
          </p>
        </div>
      </div>
    </footer>
  );
}